import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1wo9c78f: FaireBrandEntity = {
  token: "b_1wo9c78f",
  type: "brand",
  name: "Liamolly",
  avatarUrl:
    "https://cdn.faire.com/fastly/b289ee331a9590f2c63f8b8b0b0579ff73fc85b2230f334809e351b51850c98b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a9fbb81b27a75ac40e2b45834a6f30a494632d767c2b803c052f2b0aa42d24e1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b289ee331a9590f2c63f8b8b0b0579ff73fc85b2230f334809e351b51850c98b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a9fbb81b27a75ac40e2b45834a6f30a494632d767c2b803c052f2b0aa42d24e1.jpeg",
  location: "Shandaken, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 34,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a small family knitting studio. We design + make a collection of modern jacquard knitted wraps. They are made of buttery soft Italian spun 100% Organic Egyptian cotton.  They feel like cashmere. Each piece is designed, programmed +knit in our studio based int he Catskill mountains. They are easy to take care of because they are made of long staple cotton, meaning they won’t pill and are machine wash + dry. They are a travel Wrap, blanket scarf, campfire wrap, beach wrap, winter scarf, shawl, poncho, air conditioner wrap. A wool Alternative.\nLiamolly is named after my son and daughter both contribute their artwork to our collection.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:45.720Z",
    importedBy: "entity-db-cli",
  },
};
